import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    downloadActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    commentsTab,
    logsTab,
    logsTabKey,
    metadataTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import { isYamlEqual, parseYaml, serializeToPrettyYaml } from "utils/valueTransformers";
import resource from "./resource";

const resourceName = "schema";

const config: ResourceConfig = {
    label: "Schema",
    icon: IconCollection.fileCogOutline,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: logsTabKey,
    layout: [
        { partial: "pageHeaderForm" },
        { partial: "form" },
        {
            partial: "tabs",
            config: {
                tabs: [logsTab.tab, metadataTab.tab, commentsTab.tab],
                content: [logsTab.content, metadataTab.content, commentsTab.content],
            },
        },
    ],
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${resource.graphql.resourceBody}
            value
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
            $value: SchemalessData,
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
            value: $value,
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $value: SchemalessData,
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            value: $value,
        `,
    },
    actions: {
        shown: [],
        hidden: [
            duplicateActionSignature,
            downloadActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
    form: [
        {
            // TODO: use SCHEMA_MESSAGE_BODY to optionally display this as a form. see https://app.clickup.com/t/861mcccgq
            name: "value",
            component: "codeEditor",
            fieldProps: {
                lang: "yaml",
                isReadOnly: false,
                // Editable JSON⇄YAML display-mode toggle. Submitted via
                // parseYaml/isYamlEqual (both parse JSON, a YAML subset), so
                // switching the representation never marks the form dirty.
                structuredDataEdit: true,
            },
            submitDto: (value: any) => parseYaml(value),
            isEqual: isYamlEqual,
        },
    ],
    formDTO: {
        initialValueDTO: (data: any) => {
            const value = serializeToPrettyYaml(data?.value);
            return { ...data, value };
        },
    },
};
export default config;
